/**
 * Feature hook: resolved Teams request identifiers.
 * Prefers live Teams context and falls back to stored local values.
 */
import { useLogin } from "./useLogin";
import { getTeamsRequestContext as resolveTeamsRequestContext } from "../../utils/searchScope";

export function useTeamsRequestContext() {
  const { teamsContext } = useLogin();
  return resolveTeamsRequestContext(teamsContext);
}
